exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Progress-bar__container{top:100%;position:absolute;right:0;left:0;justify-self:center;margin:auto;max-width:60rem}@media screen and (max-width: 47.0625em){.Progress-bar__container{box-shadow:0 1.5rem 3.125rem 0 rgba(6,9,31,.0784313725);max-width:none}}.Progress-bar__container .MuiStep-root{background-color:#e5e5e5;height:5px;width:100%;border-right:2px solid #fff;padding:0}.Progress-bar__container .MuiStep-root svg{display:none}.Progress-bar__container .Mui-completed{background-color:#88f1c7 !important}.Progress-bar__container .Mui-disabled{background:#e5e5e5}", ""]);

// exports
